export default __webpack_public_path__ + "f25bd05915c1a3468d3d219f0502f72e.ttf";